import { CmmdApiError } from "./transport";

// ── Legacy error classes (@deprecated — use CmmdApiError instead) ─────────────

export class CmmdApiAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CmmdApiAuthError";
  }
}

export class CmmdApiServerError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "CmmdApiServerError";
    this.status = status;
  }
}

// ── Error conversion (legacy compat) ──────────────────────────────────────────

/**
 * Map transport errors onto the legacy error types long-time callers throw and
 * catch. Extracted from index.ts (forge#3516): the thread-attachment API binds
 * through it too, so every surface keeps converting identically.
 */
export async function legacyRequest<T>(promise: Promise<T>): Promise<T> {
  try {
    return await promise;
  } catch (err) {
    if (err instanceof CmmdApiError) {
      if (err.kind === "auth") throw new CmmdApiAuthError(err.message);
      throw new CmmdApiServerError(err.message, err.status ?? 502);
    }
    throw err;
  }
}
